import api from "../apis/InfluencerApi";

export const RegisterInfluencer = (data,onSuccess,onError) => dispatch => {
  api
    .Influencer()
    .Signup(data)
    .then((res) => {
      console.log(res.data);
      onSuccess(res.data)
    })
    .catch((err) => {
      if (err.code === 'ECONNABORTED'){
        onError("Timeout");
      }else{
      console.log(err.response);
      onError(err.response.data.message);
      }
    });
};

export const logininfluencer = (data,onSuccess,onError) => {
  api
    .Influencer()
    .Login(data)
    .then((res) => {
      console.log(res.data);
      onSuccess(res.data.message)
      localStorage.setItem("INFLUENCER", JSON.stringify(res.data.influencer));
      localStorage.setItem("INFLUENCER_TOKEN", JSON.stringify(res.data.token));
    })
    .catch((err) => {
      if (err.code === 'ECONNABORTED'){
        onError("Timeout");
      }else{
      console.log(err.response);
      onError(err.response.data.message);
      }
    });
};

export const RefferedUsers = (data,onSuccess,onError) => {
  api
    .Influencer()
    .Reffereduser(data)
    .then((res) => {
      console.log(res.data);
      onSuccess(res.data);
    })
    .catch((err) => {
      if (err.code === 'ECONNABORTED'){
        onError("Timeout");
      }else{
      console.log(err.response);
      onError(err.response.data.message);
      }
    });
};

export const InfluencerData = () => {
  api
    .Influencer()
    .Influencerdata()
    .then((res) => {
      console.log(res.data);
      localStorage.setItem("INFLUENCER", JSON.stringify(res.data.infuencer));
    })
    .catch((err) => {
      if (err.code === 'ECONNABORTED'){
        console.log("Timeout");
      }else{
      console.log(err.response);
      }
    });
};

export const ForgotPassword = (data,onSuccess,onError) => {
  api
    .Influencer()
    .forgotPassword(data)
    .then((res) => {
      console.log(res.data)
      onSuccess(res.data.message)
    })
    .catch((err) => {
      if (err.code === 'ECONNABORTED'){
        onError("Timeout");
      }else{
      console.log(err.response);
      onError(err.response.data.message);
      }
    });
};


export const VerifyOtp = (data,onSuccess,onError) => {
  api
    .Influencer()
    .verifyotp(data)
    .then((res) => {
      console.log(res.data)
      localStorage.setItem("VARIFYED_USER", JSON.stringify(res.data.Influencer));
      localStorage.setItem("INFLUENCER_TOKEN", JSON.stringify(res.data.Influencer.token));
      onSuccess(res.data.message)
    })
    .catch((err) => {
      if (err.code === 'ECONNABORTED'){
        onError("Timeout");
      }else{
      console.log(err.response);
      onError(err.response.data.message);
      }
    });
};

export const UpdatePassword = (data,onSuccess,onError) => {
  api
    .Influencer()
    .updatePassword(data)
    .then((res) => {
      console.log(res.data)
      const user = JSON.parse(localStorage.getItem("VARIFYED_USER"));
      localStorage.setItem("INFLUENCER", JSON.stringify(user));
      onSuccess(res.data.message)
    })
    .catch((err) => {
      if (err.code === 'ECONNABORTED'){
        onError("Timeout");
      }else{
      console.log(err.response);
      onError(err.response.data.message);
      }
    });
};

export const Changepassword = (data,onSuccess,onError) => {
  api
    .Influencer()
    .changepassword(data)
    .then((res) => {
      console.log(res.data)
      onSuccess(res.data.message)
    })
    .catch((err) => {
      if (err.code === 'ECONNABORTED'){
        onError("Timeout");
      }else{
      console.log(err.response);
      onError(err.response.data.message);
      }
    });
};